/**
 * Adding new presets
 *
 * Use naming like: [Shape][Cutout][DrillholeType]
 * - Add name with translation to ShapePresenter.php in get_presets()
 * - Create a new class inside this folder and extends AbstractPreset
 * - Run the measurements app and create the preset example and use share configration to get the config values form the console. (for example add a console.log in loadConfiguration() method)
 * - Copy the values and add to getConfig() method, remove unused values (only need base, drillholes and cutouts).
 * - Make sure to remove drillhole diameter from the config (we use always the default from the pricing group).
 * - Set presetShape in config to "presetShape": this.getName().
 * - Add the new preset to the PresetFactory presets array.
 * - Add svg icon to /components/icons and add to utils.ts
 */

import { AbstractPreset } from "./AbstractPreset";
import CircleCircleNone from "./CircleCircleNone";
import RoundedrectangleNoneCustom from "./RoundedrectangleNoneCustom";
import CircleNoneCustom from "./CircleNoneCustom";
import RectangleCircleNone from "./RectangleCircleNone";
import RectangleNoneCustom from "./RectangleNoneCustom";
import RectangleNoneEdges from "./RectangleNoneEdges";
import RectangleRectangleEdges from "./RectangleRectangleEdges";
import RectangleRectangleNone from "./RectangleRectangleNone";
import RectangleRectangleCustom from "./RectangleRectangleCustom";
import CircleNoneRadial from "./CircleNoneRadial";
import RectangleNoneGrid from "./RectangleNoneGrid";
import RoundedrectangleNoneEdges from "./RoundedrectangleNoneEdges";
import RectangleRoundedrectangleNone from "./RectangleRoundedrectangleNone";

export default class PresetFactory {
	getAll(enabledShapes: string[], cutouts: boolean, drillHoles: boolean): AbstractPreset[] {
		let presets = [
			new RectangleNoneEdges(),
			new RectangleNoneCustom(),
			new RectangleRectangleNone(),
			new RectangleCircleNone(),
			new CircleNoneCustom(),
			new RectangleNoneGrid(),
			new RoundedrectangleNoneCustom(),
			new CircleCircleNone(),
			new RectangleRectangleCustom(),
			new CircleNoneRadial(),
			new RectangleRectangleEdges(),
			new RoundedrectangleNoneEdges(),
			new RectangleRoundedrectangleNone(),
		];

		// Filter out presets that are not enabled
		presets = presets.filter( (preset) => {
			return preset.getShapes().some(shape => enabledShapes.includes(shape));
		});

		// Filter out presets with cutouts if cutouts are disabled
		presets = presets.filter( (preset) => {
			if(preset.hasCutouts()) {
				return !cutouts ? false : true;
			}

			return true;
		} );

		// Filter out presets with drillholes if drillholes are disabled
		presets = presets.filter( (preset) => {
			if(preset.hasDrillholes()) {
				return !drillHoles ? false : true;
			}
			return true;
		} );

		return presets;
	}
}
